module.exports = __webpack_public_path__ + "img/1.941ad6c1.png";